/**
 * Derives a MIME type from a filename extension (OR-22558).
 *
 * The docs-messages list and `DocDownloadResponse` don't currently carry a
 * content type, so the opener infers one from the filename to tell the viewer
 * which renderer to use. Unknown extensions fall back to
 * `application/octet-stream`, which the viewer renders as a download link.
 * When the BFF starts supplying a real MIME, prefer that over this heuristic.
 */
const EXTENSION_TO_MIME: Record<string, string> = {
  pdf: "application/pdf",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  tif: "image/tiff",
  tiff: "image/tiff",
};

/**
 * Maps a filename to a best-guess MIME type by extension.
 * @param {string | null} [fileName] - The document filename.
 * @returns {string} The inferred MIME type, or `application/octet-stream`.
 */
export function contentTypeFromFileName(fileName?: string | null): string {
  const extension = fileName?.split(".").pop()?.toLowerCase() ?? "";
  return EXTENSION_TO_MIME[extension] ?? "application/octet-stream";
}
